import { createCanvas } from "./include/module";
createCanvas();

import { detectScroll } from "./include/module";
detectScroll();

import { toggleHeader } from "./include/module";
toggleHeader();

import { anchorLink } from "./include/module";
anchorLink();



// WEBPACK FOOTER //
// script.js